import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsListComponent } from './events-list.component';

@NgModule({
  imports: [CommonModule, EventsListComponent],
  exports: [EventsListComponent],
})
export class EventsListModule {}
